<!--
  EmptyConversations — Phase 4-3 / T18.

  Zero-state for the conversation list. Two faint overlapping circles
  (suggestive of "two parties, conversation pending") + one heading + one
  sub-line. No figurative imagery, no exclamation marks.
-->
<script lang="ts">
  // Pure presentation; no props.
</script>

<div class="empty" role="status">
  <div class="art" aria-hidden="true">
    <span class="disc big"></span>
    <span class="disc small"></span>
  </div>
  <p class="heading">No conversations yet</p>
  <p class="sub">When customers message your pages, they'll show up here.</p>
</div>

<style>
  .empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 28px;
    text-align: center;
    color: var(--widget-fg);
    height: 100%;
    box-sizing: border-box;
  }
  .art {
    position: relative;
    width: 110px;
    height: 88px;
    margin-bottom: 6px;
  }
  /* Neutral discs only. Signal Amber Solitude Rule: amber lives on action
     and attention-state, never decoratively. */
  .disc {
    position: absolute;
    border-radius: 50%;
    background: var(--widget-bg-sunk);
    border: 1px solid var(--widget-divider);
  }
  .disc.big {
    width: 88px;
    height: 88px;
    top: 0;
    left: 0;
  }
  .disc.small {
    width: 64px;
    height: 64px;
    top: 22px;
    left: 46px;
  }
  .heading {
    /* Label role per DESIGN.md typography: uppercase, tight tracking. */
    margin: 0;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--widget-fg-muted);
  }
  .sub {
    margin: 0;
    font-size: 12.5px;
    font-weight: 400;
    color: var(--widget-fg-muted);
    max-width: 34ch;
    line-height: 1.45;
  }
</style>
